<!--
 * @Author: your name
 * @Date: 2021-12-16 18:17:18
 * @LastEditTime: 2022-03-23 15:07:21
 * @LastEditors: yeqing
 * @Description: 小巨人基本信息
-->
<template>
  <div>
    <div class="lit-title">
      <span class="lit-ban"></span>
      <span class="lit-txt2">企业基本信息</span>
    </div>
    <!-- 表单 -->
    <div class="lit-form">
      <div class="lit-forms">
        <span class="lit-form-tit">1、公司名称</span>
        <van-cell-group>
          <van-field
            v-model="giantForm.q511"
            @input="handleSearchCompany"
            placeholder="请输入您的企业名称，如汉唐信通"
            @focus="onFocus"
            @blur="onBlur"
          />
        </van-cell-group>
        <!-- <van-popup v-model="companyShow" round position="bottom">
          <van-picker
            title="企业名称"
            show-toolbar
            :columns="companyList"
            @confirm="handleSelectCompany"
            @cancel="companyShow = false"
          />
        </van-popup>-->
        <div v-if="companyShow" class="company_list">
          <div>
            <div
              v-for="(item, index) in companyList"
              :key="index"
              @click="handleSelectCompany(item)"
            >{{ item }}</div>
          </div>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">2、成立日期</span>
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="giantForm.q512"
          placeholder="点击选择时间"
          @click="onSelectDate"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-datetime-picker
            type="date"
            :min-date="minDate"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
      </div>

      <div class="lit-forms">
        <span class="lit-form-tit">企业未被列入经营异常名录</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
            @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业未被列入严重失信主体名单</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
            @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业提供的产品 (服务)不属于国家禁止、限制或淘汰类</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
            @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">企业近三年未发生重大安全(含网络安全、数据安全)、质量、环境污染等事故以及偷漏税等违法违规行为</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
            @click="selectClick('q513', '没有')"
          >没有</span>
          <span class="lit-radio" :class="giantForm.q513 == '有' ? 'lit-active' : ''" @click="selectClick('q513', '有')" >有</span>
        </div>
      </div>












      <div class="lit-forms">
        <span class="lit-form-tit">3、具有独立法人资格的中型、小型和微型企业：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q513 == '没有' ? 'lit-active' : ''"
            @click="selectClick('q513', '没有')"
          >没有</span>
          <span
            class="lit-radio"
            :class="giantForm.q513 == '有' ? 'lit-active' : ''"
            @click="selectClick('q513', '有')"
          >有</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">4、是否经省（直辖市）级主管部门认定为省级专精特新中小企业或专精特新小巨人企业：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q514 == '是' ? 'lit-active' : ''"
            @click="selectClick('q514', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q514 == '否' ? 'lit-active' : ''"
            @click="selectClick('q514', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">5、是否已列为工业和信息化信部制造业单项冠军企业或产品的企业：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q515 == '是' ? 'lit-active' : ''"
            @click="selectClick('q515', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q515 == '否' ? 'lit-active' : ''"
            @click="selectClick('q515', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">6、是否符合城市战略定位和产业发展政策：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q516 == '是' ? 'lit-active' : ''"
            @click="selectClick('q516', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q516 == '否' ? 'lit-active' : ''"
            @click="selectClick('q516', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">7、主要产品(服务)所属领域：</span>
        <van-field
          v-model="giantForm.q517"
          is-link
          readonly
          placeholder="请选择所属领域"
          @click="fieldShow = true"
        />
        <van-popup v-model="fieldShow" round position="bottom">
          <van-cascader
            v-model="cascaderValue"
            title="请先选择您所属领域"
            :options="options"
            @close="fieldShow = false"
            @finish="onFinish"
            :field-names="fieldNames"
          />
        </van-popup>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">8、企业近三年未发生重大安全、重大质量事故、环境污染事故：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q518 == '是' ? 'lit-active' : ''"
            @click="selectClick('q518', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q518 == '否' ? 'lit-active' : ''"
            @click="selectClick('q518', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">9、企业未发生偷税漏税或其他违法违规被处罚的情况：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q519 == '是' ? 'lit-active' : ''"
            @click="selectClick('q519', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q519 == '否' ? 'lit-active' : ''"
            @click="selectClick('q519', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span class="lit-form-tit">10、企业未发生其他严重失信行为：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q5110 == '是' ? 'lit-active' : ''"
            @click="selectClick('q5110', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q5110 == '否' ? 'lit-active' : ''"
            @click="selectClick('q5110', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span
          class="lit-form-tit"
        >11、坚持专业化发展战略，长期专注并深耕于产业链某一环节或某一产品，能为大企业、大项目提供关键零部件、元器件和配套产品，或直接面向市场并具有竞争优势的自有品牌产品：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q5111 == '是' ? 'lit-active' : ''"
            @click="selectClick('q5111', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q5111 == '否' ? 'lit-active' : ''"
            @click="selectClick('q5111', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span
          class="lit-form-tit"
        >12、具有持续创新能力和研发投入，在研发设计、生产制造、市场营销、内部管理等方面不断创新并取得比较显著的效益，具有一定的示范推广价值：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q5112 == '是' ? 'lit-active' : ''"
            @click="selectClick('q5112', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q5112 == '否' ? 'lit-active' : ''"
            @click="selectClick('q5112', '否')"
          >否</span>
        </div>
      </div>
      <div class="lit-forms">
        <span
          class="lit-form-tit"
        >13、重视并实施长期发展战略，公司治理规范、信誉良好、社会责任感强，生产技术、工艺及产品质量性能国内领先，注重绿色发展，加强人才队伍建设，有较好的品牌影响力，具备发展成为相关领域国际知名企业的潜力：</span>
        <div class="lit-radios">
          <span
            class="lit-radio"
            :class="giantForm.q5113 == '是' ? 'lit-active' : ''"
            @click="selectClick('q5113', '是')"
          >是</span>
          <span
            class="lit-radio"
            :class="giantForm.q5113 == '否' ? 'lit-active' : ''"
            @click="selectClick('q5113', '否')"
          >否</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { getCompanyInfo, getCorpInfo } from "@/api/enterpriseHighNew"
import { zjtxOptionData } from "@/utils/josnData"
import '../../index.less';
export default {
  data() {
    return {
      minDate: new Date(1970, 0, 1),
      showPicker: false,
      companyShow: false,
      isSelectDate: true,// 是否可以选择日期
      companyList: [],
      fieldShow: false,
      radio: '',
      cascaderValue: '',
      fieldValue: '',
      options: [],
      fieldNames: {
        text: 'label',
        value: 'label',
        children: 'children',
      },
      giantForm: {
        q511: '',
        q512: '',
        q513: '',
        q514: '',
        q515: '',
        q516: '',
        q517: '',
        q518: '',
        q519: '',
        q5110: '',
        q5111: '',
        q5112: '',
        q5113: '',
      },
    };
  },
  created () {
    // 处理option数据
    let options =[]
    zjtxOptionData.map(item=>{
      let children =[]
      item.children.map(item1=>{
        children.push({
           label:item1
        })
      })
      options.push({
        label:item.label,
        children:children
      })
    })
    this.options = options
  },
  methods: {
    moment,
    // 查询企业列表
    handleSearchCompany(value) {
      if (!value) {
        this.companyList = []
        this.companyShow = false
        return
      }
      let data = {
        name: value,
      };
      getCompanyInfo(data)
        .then((res) => {
          if (res.data) {
            this.companyList = [...new Set(res.data)]
            if (res.data.length > 0) {
              this.companyShow = true
            }
          }
        })
        .catch((err) => console.log(err))
    },

    // 选择企业
    handleSelectCompany(value) {
      this.giantForm.q511 = value
      this.companyShow = false
      getCorpInfo({
        companyName: value
      }).then(res => {
        if (res.data.foundedTime) {
          this.giantForm.q512 = res.data.foundedTime
          this.isSelectDate = false
        } else {
          this.isSelectDate = true
        }
      })
    },
    // 选择日期
    onSelectDate() {
      // 公司有日期返回时不可以更改日期
      if (!this.isSelectDate) {
        return
      } else {
        this.showPicker = true
      }
    },
    onConfirm(time) {
      this.giantForm.q512 = moment(time).format('YYYY-MM-DD');
      this.showPicker = false;
    },
    onFinish({ selectedOptions }) {
      this.fieldShow = false;
      this.giantForm.q517 = selectedOptions
        .map((option) => option.label)
        .join('/');
    },
    selectClick(type, val) {
      this.giantForm[type] = val;
    },

    onFocus() {
      this.$emit('onFocus')
    },
    onBlur() {
      this.$emit('onBlur')
    }
  },
};
</script>
